import { GET_USER_DETAILS_REQUEST } from './types';

// eslint-disable-next-line import/prefer-default-export
export function getUserDetails() {
  return {
    type: GET_USER_DETAILS_REQUEST,
    payload: {},
  };
}
